import React from 'react'
import { useTranslation } from 'react-i18next';
import ProjectAvatar from '../../shared/ProjectAvatar';

const LatestDisbursedProjects = ({
    mp,
    isLoan,
    isTcp,
    isIgr,
    titleLon,
    titleTcp,
    titleIgr
}) => {
    const { t } = useTranslation();

    return (
        <div className="last-disbursment-cell">
            <div className='total-project-count'>
                <h2 className='size-total-project'>{mp.projectOverall.totalProjectCount}</h2>

                <p className='align-text-count'>
                    {`${t('one_pager_report.projects')} `}<b>{t('extended_report.without_disbursements')}</b>
                </p>
                <div className="c-content project-avatar">
                    {(isLoan) && (<ProjectAvatar label={titleLon} value={mp.projectOverall.totalProjectCountLon} className="avatar-style-lon" />)}
                    {(isTcp) && (<ProjectAvatar label={titleTcp} value={mp.projectOverall.totalProjectCountTcp} className="avatar-style-tcp" />)}
                    {(isIgr) && (<ProjectAvatar label={titleIgr} value={mp.projectOverall.totalProjectCountIgr} className="avatar-style-igr" />)}
                </div>
            </div>
        </div>
    )
}

export default LatestDisbursedProjects